import { render, staticRenderFns } from "./AnimatedIcon.vue?vue&type=template&id=1d8b257d&scoped=true&lang=html&"
import script from "./AnimatedIcon.vue?vue&type=script&lang=js&"
export * from "./AnimatedIcon.vue?vue&type=script&lang=js&"
import style0 from "./AnimatedIcon.vue?vue&type=style&index=0&id=1d8b257d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8b257d",
  null
  
)

export default component.exports